module.exports = __webpack_public_path__ + "static/media/TW.893fdc0d.png";